// extracted by mini-css-extract-plugin
export default {"backdrop":"VideoZoom_backdrop__DdZEX","videoContainer":"VideoZoom_videoContainer__kFcbk","video":"VideoZoom_video__0ht8T"};